<template lang="pug">
  div
    div(class="counter")
      user-counter-item(:count="1125", :width="11.2")
      user-counter-item(:count="1303", :width="13", :dn="61")
      user-counter-item(:count="1559", :width="15.6", :dn="71")
      user-counter-item(:count="1836", :width="18.4", :dn="83")
      user-counter-item(:count="2258", :width="22.6", :dn="97")
      user-counter-item(:count="2684", :width="26.8", :dn="127")
      user-counter-item(:count="3134", :width="31.3", :dn="137")
      div(class="padding")
      user-counter-item(:count="3633", :width="36.3", :dn="157")
      user-counter-item(:count="4119", :width="41.2", :dn="181")
      user-counter-item(:count="4456", :width="44.6", :dn="211")
      user-counter-item(:count="4869", :width="48.7", :dn="229")
      user-counter-item(:count="5275", :width="52.8", :dn="241")
      user-counter-item(:count="5693", :width="56.9", :dn="271")
      user-counter-item(:count="6128", :width="61.3", :dn="293")
      user-counter-item(:count="6798", :width="68", :dn="317")
      user-counter-item(:count="7591", :width="75.9", :dn="367")
      user-counter-item(:count="8280", :width="82.8", :dn="401")
      user-counter-item(:count="8954", :width="89.5", :dn="433")
      user-counter-item(:count="9654", :width="96.5", :dn="467")
      div(class="padding")
      user-counter-item(:count="10000", :width="100", :dn="499")
</template>
<script>
  import UserCounterItem from 'modules/components/Event/Infographics/UserCounterItem.vue';

  export default {
    components: {
      UserCounterItem,
    },
  };
</script>
<style lang="scss" scoped>
  .counter {
    padding-top: 81px;
    @include mq('sm') {
      padding-top: 105px;
    }
  }
  .padding {
    padding-bottom: 82px;
    @include mq('sm') {
      padding-bottom: 86px;
    }
  }
</style>
